import { Directive, ElementRef, Input, HostListener, HostBinding, Renderer2 } from '@angular/core';

@Directive({ selector: '[Blink]' })

export class BlinkDirective {

  constructor(el: ElementRef, renderer: Renderer2) {
    var active: boolean = false
    var intervalId = null;


    setInterval(() => {
      if (!el.nativeElement.disabled && !active) {
        active = true;
        el.nativeElement.classList.add("back2");
        intervalId = setInterval(function () {
          el.nativeElement.classList.toggle("back2");
          el.nativeElement.classList.toggle("back1");
        }, 750);

      }
      else if (el.nativeElement.disabled && active) {
        active = false;
        el.nativeElement.classList.remove("back2");
        el.nativeElement.classList.remove("back1");
        if (intervalId) {
          clearInterval(intervalId);
        }
      }
    }, 750);
  }
}
